<template>
  <el-dialog
    title="新增收货单"
    custom-class="confirm-receipt-dialog"
    :visible.sync="dialogVisible"
    width="1380px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="receipt-toolbar">
      <el-checkbox v-model="isFinal">本批为最终收货</el-checkbox>
      <span class="receipt-toolbar-tip">
        {{
          isFinal
            ? "最终收货将认定缺货（已退货换货数量会从质检扣减中加回）；补发良品仍通过本批实收录入"
            : "进度收货不认定缺货，采购单仍为待收货，可继续分批收货"
        }}
      </span>
    </div>
    <el-table
      :data="skuList"
      border
      stripe
      size="mini"
      max-height="480"
      show-summary
      :summary-method="getSummaries"
      v-loading="loading"
      element-loading-text="加载中..."
      class="receipt-table"
    >
      <el-table-column type="index" label="序号" width="48" align="center"></el-table-column>
      <el-table-column prop="date" label="采购日期" width="90" align="center"></el-table-column>
      <el-table-column prop="sku" label="SKU" min-width="220" show-overflow-tooltip></el-table-column>
      <el-table-column prop="fnsku" label="FNSKU" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productName" label="产品名称" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseColorName" label="颜色" width="65" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="model" label="型号" width="80" align="left" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseQuantity" label="采购数量" width="60" align="right">
        <template slot="header">
          <span title="点击单元格可自动填写本批实收（采购数量−已累计实收）">采购数量</span>
        </template>
        <template slot-scope="scope">
          <span
            class="purchase-qty-fill"
            title="点击填入本批实收：采购数量−已累计实收"
            @click="fillBatchArrivedFromPurchaseQty(scope.row)"
          >
            {{ scope.row.purchaseQuantity }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="prevBatchArrived" label="已累计实收" width="60" align="right"></el-table-column>
      <el-table-column prop="prevQualityFail" label="已累计质检不合格" width="60" align="right"></el-table-column>
      <el-table-column prop="exchangedQty" label="换货数量" width="60" align="right"></el-table-column>
      <el-table-column prop="returnedExchangeQty" label="已退货换货" width="60" align="right"></el-table-column>
      <el-table-column prop="batchArrived" label="本批实收" width="80" align="center">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            placeholder=""
            v-model="scope.row.batchArrived"
            @input="onBatchArrivedInput(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="qualityFail" label="质检不合格" width="80" align="center">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            placeholder=""
            v-model="scope.row.qualityFail"
            @input="onQualityFailInput(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="overStock" label="多到数量" width="80" align="center">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            placeholder=""
            v-model="scope.row.overStock"
            @input="recalcPreview(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column v-if="isFinal" prop="outOfStockPreview" label="缺货(认定)" width="60" align="right"></el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { requestModules } from "@r";
import { isPreSettleStatus } from "./purchaseOrderStatus.js";

const SUM_PROPS = [
  "purchaseQuantity",
  "prevBatchArrived",
  "prevQualityFail",
  "exchangedQty",
  "returnedExchangeQty",
  "batchArrived",
  "qualityFail",
  "overStock",
  "outOfStockPreview",
];

export default {
  name: "ConfirmReceiptDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      isFinal: false,
      skuList: [],
      selectedOrders: [],
    };
  },
  methods: {
    open(selectedList) {
      this.dialogVisible = true;
      this.isFinal = false;
      this.skuList = [];
      this.selectedOrders = selectedList || [];
      this.loadSkus(selectedList || []);
    },
    toEmptyOrNumber(value) {
      const n = Number(value);
      if (!value && value !== 0) return "";
      if (!n) return "";
      return n;
    },
    toNumberOrZero(value) {
      if (value === "" || value === null || value === undefined) return 0;
      return Number(value) || 0;
    },
    /** 最终收货：本批实收按剩余可收默认填充；进度收货：默认留空 */
    resolveDefaultBatchArrived(row) {
      if (!this.isFinal) {
        return "";
      }
      if (row.batchArrived !== undefined && row.batchArrived !== null && row.batchArrived !== "") {
        return Number(row.batchArrived) || 0;
      }
      return Number(row.remainHint) || 0;
    },
    syncBatchArrivedBase(row) {
      if (row.batchArrived === "" || row.batchArrived === null || row.batchArrived === undefined) {
        row._batchArrivedBase = "";
        return;
      }
      row._batchArrivedBase = this.toNumberOrZero(row.batchArrived) + this.toNumberOrZero(row.qualityFail);
    },
    /** 本批实收 = 基数 − 质检不合格（有基数时才联动） */
    applyQualityFailToBatchArrived(row) {
      if (row._batchArrivedBase === "" || row._batchArrivedBase === null || row._batchArrivedBase === undefined) {
        return;
      }
      const base = this.toNumberOrZero(row._batchArrivedBase);
      const qualityFail = this.toNumberOrZero(row.qualityFail);
      row.batchArrived = Math.max(0, base - qualityFail);
    },
    onBatchArrivedInput(row) {
      this.syncBatchArrivedBase(row);
      this.recalcPreview(row);
    },
    /** 点击采购数量：本批实收 = 采购数量 − 已累计实收 */
    fillBatchArrivedFromPurchaseQty(row) {
      const plan = Number(row.purchaseQuantity != null ? row.purchaseQuantity : row.planPurchase) || 0;
      const prevBatch = Number(row.prevBatchArrived) || 0;
      row.batchArrived = Math.max(0, plan - prevBatch);
      this.syncBatchArrivedBase(row);
      this.recalcPreview(row);
    },
    onQualityFailInput(row) {
      this.applyQualityFailToBatchArrived(row);
      this.recalcPreview(row);
    },
    applyBatchArrivedDefaults() {
      (this.skuList || []).forEach(row => {
        if (this.isFinal) {
          const base = Number(row.remainHint) || 0;
          row._batchArrivedBase = base;
          row.batchArrived = Math.max(0, base - this.toNumberOrZero(row.qualityFail));
        } else {
          row._batchArrivedBase = "";
          row.batchArrived = "";
        }
        this.recalcPreview(row);
      });
    },
    loadSkus(selectedList) {
      this.loading = true;
      requestModules
        .fetchPurchaseOrderReceiptSkus({
          selectedList: JSON.stringify(selectedList),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取收货明细失败");
            this.dialogVisible = false;
            return;
          }
          this.skuList = (res.ldata || []).map(row => {
            const batchArrived = this.resolveDefaultBatchArrived(row);
            const qualityFail = this.toEmptyOrNumber(row.qualityFail);
            const next = {
              ...row,
              prevBatchArrived: Number(row.prevBatchArrived) || 0,
              prevQualityFail: Number(row.prevQualityFail) || 0,
              prevOverStock: Number(row.prevOverStock) || 0,
              exchangedQty: Number(row.exchangedQty) || 0,
              returnedExchangeQty: Number(row.returnedExchangeQty) || 0,
              remainHint: Number(row.remainHint) || 0,
              batchArrived,
              qualityFail,
              overStock: this.toEmptyOrNumber(row.overStock),
              outOfStockPreview: 0,
              _batchArrivedBase: batchArrived === "" || batchArrived === null || batchArrived === undefined ? "" : this.toNumberOrZero(batchArrived) + this.toNumberOrZero(qualityFail),
            };
            this.applyQualityFailToBatchArrived(next);
            this.recalcPreview(next);
            return next;
          });
        })
        .catch(() => {
          this.$message.error("获取收货明细失败");
          this.dialogVisible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    recalcPreview(row) {
      const plan = Number(row.purchaseQuantity != null ? row.purchaseQuantity : row.planPurchase) || 0;
      const prevBatch = Number(row.prevBatchArrived) || 0;
      const prevQf = Number(row.prevQualityFail) || 0;
      const batchArrived = this.toNumberOrZero(row.batchArrived);
      const qualityFail = this.toNumberOrZero(row.qualityFail);
      const cumQualityFail = prevQf + qualityFail;
      const returnedExchangeQty = Number(row.returnedExchangeQty) || 0;
      const effectiveReturned = Math.min(returnedExchangeQty, cumQualityFail);
      row.outOfStockPreview = Math.max(0, plan - prevBatch - batchArrived - cumQualityFail + effectiveReturned);
    },
    getSummaries({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (SUM_PROPS.includes(column.property)) {
          sums[index] = this.sumBy(data, column.property);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    sumBy(data, key) {
      return (data || []).reduce((total, row) => total + (Number(row[key]) || 0), 0);
    },
    submit() {
      if (!this.skuList.length) {
        this.$message.warning("没有可确认的收货明细");
        return;
      }
      for (let i = 0; i < this.skuList.length; i++) {
        const row = this.skuList[i];
        const batchArrived = this.toNumberOrZero(row.batchArrived);
        const qualityFail = this.toNumberOrZero(row.qualityFail);
        const overStock = this.toNumberOrZero(row.overStock);
        if (batchArrived < 0 || qualityFail < 0 || overStock < 0) {
          this.$message.warning("本批实收/质检不合格/多到数量不能为负数");
          return;
        }
        const plan = Number(row.purchaseQuantity != null ? row.purchaseQuantity : row.planPurchase) || 0;
        const prevBatch = Number(row.prevBatchArrived) || 0;
        const prevOver = Number(row.prevOverStock) || 0;
        if (prevBatch + batchArrived > plan + prevOver + overStock) {
          this.$message.warning(`SKU ${row.sku || ""} 累计实收超过采购数量（多到须显式录入）`);
          return;
        }
        this.recalcPreview(row);
      }

      this.submitting = true;
      requestModules
        .confirmPurchaseOrderReceipt({
          isFinal: this.isFinal ? "1" : "0",
          skuList: JSON.stringify(
            this.skuList.map(row => ({
              _id: row._id,
              batchArrived: this.toNumberOrZero(row.batchArrived),
              qualityFail: this.toNumberOrZero(row.qualityFail),
              overStock: this.toNumberOrZero(row.overStock),
            }))
          ),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "新增收货单失败");
            return;
          }
          const preSettle = (this.selectedOrders || []).some(row =>
            isPreSettleStatus(row && (row.purchaseStatus != null ? row.purchaseStatus : row.status))
          );
          if (this.isFinal && preSettle) {
            this.$message.success("最终收货成功（采购单仍待下单/待支付，支付完成后自动结案）");
          } else {
            this.$message.success(this.isFinal ? "最终收货成功" : "进度收货成功");
          }
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(() => {
          this.$message.error("新增收货单失败");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    handleClose() {
      this.skuList = [];
      this.selectedOrders = [];
      this.isFinal = false;
    },
  },
  watch: {
    isFinal() {
      this.applyBatchArrivedDefaults();
    },
  },
};
</script>

<style lang="scss">
.confirm-receipt-dialog {
  .el-dialog__body {
    overflow-x: hidden;
    padding: 12px 16px;
  }

  .receipt-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    .receipt-toolbar-tip {
      color: #909399;
      font-size: 12px;
    }
  }

  .receipt-table {
    width: 100%;

    .purchase-qty-fill {
      color: #409eff;
      cursor: pointer;
      user-select: none;
    }

    .el-table__body-wrapper,
    .el-table__header-wrapper,
    .el-table__footer-wrapper {
      overflow-x: hidden !important;
    }

    .el-input--mini .el-input__inner {
      padding: 0 4px;
      height: 26px;
      line-height: 26px;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
}
</style>
